import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import * as de from "./translations.de.json"
import * as en from "./translations.en.json"
import * as es from "./translations.es.json"
import * as it from "./translations.it.json"
import * as fr from "./translations.fr.json"
import * as pl from "./translations.pl.json"
import * as pt from "./translations.pt.json"
import * as tr from "./translations.tr.json"
import LanguageDetector from "i18next-browser-languagedetector";
const resources = {
    de: {
        translation: de,
    },
    en: {
        translation: en,
    },
    es: {
        translation: es,
    },
    fr: {
        translation: fr,
    },
    it: {
        translation: it,
    },
    pl: {
        translation: pl,
    },
    pt: {
        translation: pt,
    },
    tr: {
        translation: tr,
    },
};
i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        // Remove resources from here
        fallbackLng: 'en',
        detection: {
          order: ['navigator', 'path', 'querystring', 'subdomain', 'localStorage', 'cookie', 'sessionStorage', 'htmlTag'],
        },
        interpolation: {
            escapeValue: false,
        },
        supportedLngs: ["de", "en", "es", "fr", "it", "pl", "pt", "tr"],
        debug: process.env.NODE_ENV === "development",
    });
export default i18next;